import {booleanAttribute, ChangeDetectionStrategy, Component, input, numberAttribute} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Mimeinfo} from "felles-ng2/støttefunksjoner/mimetyper";
import {MatIcon} from "@angular/material/icon";

const debug = initDebugger('DokumentFormatIkonKomponent');

/**
 * Viser format-ikon for angitt mimetype
 */
@Component({
    selector: 'dokument-format-ikon',
    template: `
        <i class="lederplan-ikon-dokument"></i>
        <mat-icon [fontSet]="mimeinfo().ikon" class="mat-icon--lederplan-ikon" [style.font-size]="stoerrelse()+'px'" [style.width]="(stoerrelse()*1.075)+'px'" [style.height]="(stoerrelse()*1.075)+'px'"/>
    `,
    styleUrl: 'dokument-format-ikon.scss',
    host: {
        '[class.uten-dokumentramme]': 'utenDokumentramme()'
    },
    imports: [
        MatIcon
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DokumentFormatIkonKomponent {

    mimeinfo = input.required<Mimeinfo>();
    utenDokumentramme = input(false, {transform: booleanAttribute});
    /** Ikonets størrelse i piksler, bør KUN benyttes sammen med utenDokumentramme=false */
    stoerrelse = input(11, {transform: numberAttribute});

    constructor() {

    }
}
